import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { getParams } from '@hglobal/fin-ui';
import { Observable } from 'rxjs';

import { environment } from '@iw/environment';

import { OrdersHistoryApi } from '.';
import { GetOrdersReq, GetOrdersRes } from '../models';
import { GetOrderRes } from '../models/get-order-res.model';
import { SendCommentReq } from '../models/send-comment-req.model';

@Injectable()
export class OrdersHistoryApiService implements OrdersHistoryApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;

  getOrders(params: GetOrdersReq): Observable<GetOrdersRes> {
    const api = `${this.#apiHost}operations/`;

    return this.#http.post<GetOrdersRes>(
      api,
      getParams(params, ['account', 'category', 'status'], true),
    );
  }

  getOrder(params: { id: string }): Observable<GetOrderRes> {
    const api = `${this.#apiHost}operations/withdrawals/${params.id}/`;

    return this.#http.get<GetOrderRes>(api);
  }

  cancelOrder(params: { id: string }): Observable<void> {
    const api = `${this.#apiHost}operations/withdrawals/cancel/`;

    return this.#http.patch<void>(api, { operationId: params.id });
  }

  sendComment(params: SendCommentReq): Observable<void> {
    const api = `${this.#apiHost}operations/withdrawals/comments/`;

    return this.#http.post<void>(api, params);
  }
}
